<template>
  <div class="mod-rm__coursetrainerrela">
    <div style="margin-top: 5px;">
      <el-row :gutter="10">
         <!--添加培训师-->
        <el-col :span="15">
          <el-tabs v-model="choseType" type="border-card" class="mod-rm-coursetrainerrela-tab">
            <!-- 根据培训师查询 -->
            <el-tab-pane :label="$t('res.coursetrainerrela.alternativeTrainer')" name="0">
              <!--查询培训师-->
              <el-row>
                <el-col :span="24">
                  <div ref="queryBox"
                      class="queryBox">
                    <el-form :label-position="labelPosition"
                              :label-width="queryLabelWidth"
                              class="traninerPool-search-condition"
                              :model="dataForm">
                      <el-row :gutter="0">
                        <!-- 培训师 -->
                        <el-col :span="7">
                         <el-form-item class="oneBoxTrainer" :label="$t('res.coursetrainerrela.trainer')">
                            <el-input v-model="dataForm.trainer"
                                        clearable
                                        :placeholder="$t('res.coursetrainerrela.trainerPlaceholder')"></el-input>
                          </el-form-item>
                        </el-col>
                        <!-- 培训师标签 -->
                        <el-col :span="7">
                           <el-form-item class="search-item oneBoxTrainerLabel" style="height: 34px;">
                            <span slot="label">
                              <el-link type="primary" :underline="false" slot="reference"
                                        @click.native.prevent="showSuboLableDlg">{{ $t('res.coursetrainerrela.trainerLabel')}}</el-link>
                            </span>
                            <div class="el-input el-input--default el-input__inner" style="height:30px;" @mouseenter="trainerLabelShow()" @mouseleave="trainerLabelLeave()" >
                              <div style="width:80%;float:left;" class="holder" contenteditable="false" :placeholder="$t('cert.selectTips')">{{this.dataForm.labelTypeIdName}}</div>
                              <el-link type="primary" :underline="false" class="el-icon-error link-delete-temp" ref="trainerLabelLink" v-show="trainerLabelShowFlg && dataForm.labelTypeIdName != '' && dataForm.labelTypeIdName != null" style="float:right;margin-top:9px;color:rgba(0,0,0,.3);" @click="cleartrainerLabelName()"></el-link>
                            </div>
                          </el-form-item>
                        </el-col>
                        <!-- 培训师团队分类 -->
                        <el-col class="oneClassificationTrainersCol" :span="7">
                          <el-form-item :label="$t('res.coursetrainerrela.trainerfication')" prop="trainerficationArray">
                            <class-tree ref="trainerficationRef"
                                        v-on:getSelectList="getTrainerficationList"
                                        v-bind:defaultProps="trainerficationProps"
                                        v-bind:url="queryTrainerficationTreeUrl"
                                        v-bind:isSelect=false></class-tree>
                          </el-form-item>
                        </el-col>
                        <el-col :span="3"
                                class="query-button">
                          <el-col :span="24">
                            <!--查询按钮-->
                            <el-button class="M-search"
                                      style="margin-top: 27px;"
                                      type="primary"
                                      @click="queryTrainerInfo()">{{ $t('query') }}</el-button>
                          </el-col>
                        </el-col>
                      </el-row>
                      <el-row :gutter="0">
                        <el-col :span="7">
                          <!--所在城市-->
                          <el-form-item class="twoPopupCity" :label="$t('res.coursetrainerrela.city')" prop="cityList">
                          <class-tree ref="cityclassRef"
                                      v-on:getSelectList="getCitySelectList"
                                      v-bind:defaultProps="citydefaultProps"
                                      v-bind:isOpen=false
                                      v-bind:url="queryCityTreeUrl"
                                      v-bind:isSelect=false></class-tree>
                          </el-form-item>
                        </el-col>
                        <!-- 所属公司 -->
                        <el-col :span="7">
                          <el-form-item class="twoPopupCity module-company-select" :label="$t('res.coursetrainerrela.searchCompany')" prop="company">
                            <el-select
                              v-model="dataForm.orgId"
                              filterable
                              remote
                              reserve-keyword
                              clearable
                              :placeholder="$t('res.coursetrainerrela.searchCompany')"
                              :remote-method="remoteCompanyMethod"
                              v-loading="companyLoading">
                              <el-option
                                v-for="(item,index) in companyOptions"
                                :key="'company'+index"
                                :label="item.orgCode +'-'+item.abbreviationCn"
                                :value="item.orgId">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="7">&nbsp;</el-col>
                        <!-- 重置按钮 -->
                        <el-col :span="3"
                                class="query-button">
                          <el-col :span="24">
                            <el-button class="el-back M-search M-margin-l"
                                      type="info"
                                      @click="resetQuery()">{{ $t('reset') }}</el-button>
                          </el-col>
                        </el-col>
                      </el-row>
                    </el-form>
                  </div>
                </el-col>
              </el-row>
              <!-- 数据网格 -->
              <div class="dataBox">
                <el-table border
                          ref="selectTrainerinfo"
                          :data="dataList"
                          v-loading="dataListLoading"
                          size="mini"
                          stripe
                          @select="selectRedio"
                          @select-all="selectAllRedio">
                  <el-table-column type="selection"
                                  header-align="center"
                                  align="center"
                                  width="50"
                                  :selectable='checkboxT'>
                  </el-table-column>
                  <el-table-column prop="xh"
                                  fixed
                                  :label="$t('res.courseclassroomrela.serialNo')"
                                  type="index"
                                  min-width="55"
                                  header-align="center"
                                  align="center" />
                  <el-table-column :prop="item.prop"
                                  show-overflow-tooltip
                                  header-align="center"
                                  v-for="item in teacherList"
                                  :key="item.prop"
                                  align="center"
                                  :formatter="item.formatter"
                                  :width="item.width"
                                  :label="item.label">
                  </el-table-column>
                </el-table>
                <el-pagination @size-change="pageSizeChangeHandle"
                              @current-change="pageCurrentChangeHandle"
                              :current-page="page"
                              :page-sizes="[10, 20, 50, 100]"
                              :page-size="limit"
                              layout="total, sizes, prev, pager, next, jumper"
                              :total="total">
                </el-pagination>
              </div>
            </el-tab-pane>
            <!-- 根据课程查询 -->
            <el-tab-pane :label="$t('res.coursetrainerrela.baseCourseChose')" name="1">
              <div class="rm-course-chose-li clearfix">
                <div class="chose-li-module clearfix">
                  <span class="module-name">{{ $t('res.coursetrainerrela.courseNameCode') }}</span>
                  <span class="module-value module-value2">
                    <el-select
                      v-model="courseNameCode"
                      filterable
                      remote
                      reserve-keyword
                      :placeholder="$t('res.coursetrainerrela.courseNameCode')"
                      :remote-method="remoteMethod"
                      clearable
                      :loading="loading">
                      <el-option
                        v-for="(item,index) in options"
                        :key="'course'+index"
                        :label="item.courseCode +'-'+item.courseNameCn"
                        :value="item.courseCode">
                      </el-option>
                    </el-select>
                  </span>
                </div>
                <div class="chose-li-module chose-li-module3 clearfix">
                  <el-button style="display: inline;"
                                 class="search"
                                 type="primary"
                                 size="mini"
                                 @click="searchPool">{{ $t('res.courseclassroomrela.determine') }}</el-button>
                </div>
                <div class="chose-li-module chose-li-module2 clearfix" v-if="trainerPoolShow">
                  <span class="module-name">{{ $t('res.coursetrainerrela.trainerpool') }}</span>
                  <span class="module-value">
                    <el-select v-model="dataForms.trainerPool"
                                @change="setPoolTeacher(dataForms.trainerPool)">
                      <el-option v-for="(item,index) in trainerPool"
                                  :key="index"
                                  :label="$t('res.coursetrainerrela.trainerpool')+(index+1)"
                                  :value="item.poolId">
                      </el-option>
                    </el-select>
                  </span>
                </div>
                <div class="chose-li-module chose-li-module2 clearfix" v-if="trainerPoolShow">
                  <span class="module-name">{{ $t('res.coursetrainerrela.isQaulified') }}</span>
                  <span class="module-value">
                    <el-select v-model="isQualified"
                                @change="filterPoolTeacher">
                      <el-option v-for="(item,index) in qualficationList"
                                  :key="'isQualfied' + index"
                                  :label="item.name"
                                  :value="item.value">
                      </el-option>
                    </el-select>
                  </span>
                </div>
              </div>
               <!-- 数据网格 -->
              <div class="dataBox">
                <el-table border
                          ref="selectTrainerinfo2"
                          :data="dataList2"
                          v-loading="dataListLoading2"
                          size="mini"
                          stripe
                          @select="selectRedio"
                          @select-all="selectAllRedio">
                  <el-table-column type="selection"
                                  header-align="center"
                                  align="center"
                                  width="50"
                                  :selectable='checkboxT'>
                  </el-table-column>
                  <el-table-column prop="xh"
                                  fixed
                                  :label="$t('res.courseclassroomrela.serialNo')"
                                  type="index"
                                  min-width="55"
                                  header-align="center"
                                  align="center" />
                  <el-table-column :prop="item.prop"
                                  show-overflow-tooltip
                                  header-align="center"
                                  v-for="item in teacherList"
                                  :key="item.prop"
                                  align="center"
                                  :formatter="item.formatter"
                                  :width="item.width"
                                  :label="item.label">
                  </el-table-column>
                </el-table>
                <el-pagination @size-change="pageSizeChangeHandle2"
                              @current-change="pageCurrentChangeHandle2"
                              :current-page="page2"
                              :page-sizes="[10, 20, 50, 100]"
                              :page-size="limit2"
                              layout="total, sizes, prev, pager, next, jumper"
                              :total="total2">
                </el-pagination>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-col>
        <!--已选培训师-->
        <el-col :span="9" class="chose-tab-contain">
          <el-card>
            <div v-if="choseType==='0'">
              <el-form :model="dataForms"
                       :rules="dataRule"
                       :inline="true"
                       ref="dataForms"
                       label-position="left"
                       label-width="auto">
                  <!-- 优先级 -->
                  <el-form-item class="trainer-pool-li clearfix" prop="priority">
                    <div class="pool-module clearfix">
                      <span class="pool-module-name">{{ $t('res.courseclassroomrela.priority') }}</span>
                      <span class="pool-module-value">
                        <el-select size="mini"
                                   v-model="dataForms.priority"
                                   clearable>
                          <el-option v-for="(item,index) in priorityArr"
                                     :key="index"
                                     :label="item.name"
                                     :value="item.code">
                          </el-option>
                        </el-select>
                      </span>
                    </div>
                  </el-form-item>
                  <!-- 合格 -->
                  <el-form-item :class="['trainer-pool-li','clearfix', {'nomargin': dataForms.qualfication==='20'}]" prop="qualfication">
                    <div class="pool-module clearfix">
                      <span class="pool-module-name">{{ $t('res.coursetrainerrela.qualfication') }}</span>
                      <span class="pool-module-value">
                        <el-select size="mini"
                                   v-model="dataForms.qualfication"
                                   clearable>
                          <el-option v-for="(item,index) in qualficationArr"
                                     :key="index"
                                     :label="item.name"
                                     :value="item.code">
                          </el-option>
                        </el-select>
                      </span>
                    </div>
                    <div class="pool-module clearfix" v-if="dataForms.qualfication==='20'">
                      <span class="pool-module-value">
                        <el-date-picker
                          v-model="dataForms.qualficationDate"
                          type="date"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :picker-options="pickerOptions"
                          :placeholder="$t('user.checkdate')">
                        </el-date-picker>
                      </span>
                    </div>
                  </el-form-item>
                  <el-form-item v-if="dataForms.qualfication==='20'" prop="qualficationDate" class="trainer-pool-li trainer-pool-li3 clearfix">
                  </el-form-item>
                  <!-- 年度授课目标 -->
                  <el-form-item class="trainer-pool-li clearfix" prop="yearTarget">
                    <div class="pool-module clearfix">
                      <span class="pool-module-name">{{ $t('res.coursetrainerrela.yearTeachGoals') }}</span>
                      <span class="pool-module-value">
                        <el-select v-model="dataForms.yearTargetIndex" size="mini">
                          <el-option v-for="(item,index) in goalList"
                                      :key="'goal'+index"
                                      :label="item.label"
                                      :value="item.value">
                          </el-option>
                        </el-select>
                      </span>
                    </div>
                    <div class="pool-module clearfix" v-if="dataForms.yearTargetIndex===1">
                      <span class="pool-module-value">
                        <el-input-number v-model="dataForms.yearTarget" :min="1" :step="1" :precision="0" :max="999999"></el-input-number>
                      </span>
                    </div>
                  </el-form-item>
                  <el-form-item class="trainer-pool-li trainer-pool-li2 clearfix">
                    <el-button style="display: inline;"
                                 class="search"
                                 type="primary"
                                 size="mini"
                                 @click="onOk">{{ $t('res.courseclassroomrela.determine') }}</el-button>
                  </el-form-item>
              </el-form>
            </div>
            <div v-else style="text-align:right">
              <el-button style="display: inline;"
                                 class="search"
                                 type="primary"
                                 size="mini"
                                 @click="onOk2">{{ $t('res.courseclassroomrela.determine') }}</el-button>
            </div>
          </el-card>
          <el-card class="box-card">
            <div>
              <span class="dataBox">{{$t('res.courseclassroomrela.selected')}}</span>
              <div>
                <el-row :gutter="10">
                  <el-col v-for="(tag,index) in trainerData"
                          :key="tag.trainerId">
                    <el-tag class="trainer-chosed-tag"
                            :key="tag.trainerId"
                            @close="handleClose(tag, index)"
                            closable>{{tag.userName}}</el-tag>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <!--标签查询条件-->
    <el-dialog title="选择标签"
              :visible="isQueryShowLable"
              width="70%"
              append-to-body
              :before-close="showQueryLableClose">
      <el-form label-position="top"
              label-width="150px"
              :ref="dataForm">
        <div>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="tagName"
                            style="width: 100%!important;">
                <Tag :checkedList="checkList"
                    :moduleId="moduleId"
                    :overLabelShow = "true"
                    :closeShow = "true"
                    :bussinessTypeId = "bussinessTypeId"
                    :brandCode="bussinessTypeChecked"
                    @getBussinessType="getBussinessType"
                    @changeCheckedList="changeCheckedList"
                    ref='tagTree'
                    @fatherMethod="fatherMethod"></Tag>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div>
        <el-button type="primary"
                  @click="onOkLable">{{ $t('res.rela.determine') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import mixinViewModule from '@/mixins/view-module'
import ClassTree from '@/components/rm/class-tree/index'
import Tag from '@/components/rm/label-select/index'
import VueI18n from '@/i18n'
import Vue from 'vue'
export default {
  props: {
    trainerInfoList: {
      type: Array,
      required: false
    }
  },
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/rm/coursetrainerrela/queryTrainerlist',
        getDataListIsPage: true,
        deleteURL: '/rm/coursetrainerrela/delete',
        deleteIsBatch: true,
        exportURL: '/rm/coursetrainerrela/export'
      },
      dataForm: {
        trainer: '',
        trainerLabel: '',
        trainerfication: '',
        cityList: [],
        orgId: ''
      },
      dataForms: {
        priority: '1',
        qualfication: '10',
        yearTargetIndex: 0,
        trainerPool: ''
      },
      qualficationList: [
        { name: this.$t('res.coursetrainerrela.isQaulifiedAll'), value: 1 },
        { name: this.$t('res.coursetrainerrela.isQaulifiedOnly'), value: 2 },
      ],
      isQueryShowLable: false,
      isShowLable: false,
      trainerLabelShowFlg: false,
      checkList: [],
      // 模块id，20 代表组织管理模块
      moduleId: '20',
      bussinessTypeId: 7,
      bussinessTypeChecked: 7,
      // 已选培训师
      trainerData: [],
      trainerInfo: {},
      statusArr: this.enums['status'], // 状态下拉框
      priorityArr: this.enums['priority'], // 优先级
      trainerficationArr: this.enums['teaTeamClass'], // 培训师团队分类
      qualficationArr: this.enums['qualfication'], // 资格
      dataList: [],
      dataList2: [],
      dataListLoading: false,
      dataListLoading2: false,
      // 城市分类
      citydefaultProps: {
        children: 'childrenRegionList',
        label: 'regionNameCn'
      },
      queryCityTreeUrl: '/rm/courseclassroomrela/queryregiontree',
      // 标签树
      commLabelProps: {
        children: 'children',
        label: 'labelNameCn'
      },
      querycommLabelUrl: '/rm/coursetrainerrela/queryCommLabelNodeByNameRela',
      // 培训师团队分类
      trainerficationProps: {
        children: 'children',
        label: 'treamCnName'
      },
      queryTrainerficationTreeUrl: '/rm/rpc/treamClassTree/list',
      // 编辑面板标签对齐方式
      labelPosition: 'top',
      // 查询面板标签宽度
      queryLabelWidth: '100',
      trainerLabelList: [], // 标签
      dataRule: {
        priority: [
          { required: true, message: this.$t('res.courseclassroomrela.priorityCheck'), trigger: 'change' }
        ],
        qualfication: [
          { required: true, message: this.$t('res.coursetrainerrela.qualficationCheck'), trigger: 'change' }
        ],
        qualficationDate: [
          { required: true, message: this.$t('res.coursetrainerrela.qualficationCheck'), trigger: 'change' }
        ],
        yearTarget: [
          { required: true, message: this.$t('res.coursetrainerrela.yearTargetCheck'), trigger: 'change' }
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
        }
      },
      // 年度授课目标 限制不限制
      goalList: [
        { label: this.$t('couse.limit'), value: 1 },
        { label: this.$t('couse.dealerwx'), value: 2 }
      ],
      choseType: '0',
      courseNameCode: '',
      trainerPoolShow: false,
      trainerpool: [],
      page2: 1,
      limit2: 10,
      total2: 0,
      options: [],
      loading: false,
      teacherList: [
        { prop: 'userName', label: this.$t('res.coursetrainerrela.trainerUserName'), width: 100 },
        { prop: 'userCardNo', label: this.$t('res.coursetrainerrela.userCardNo'), width: 100 },
        { prop: 'trainerName', label: this.$t('res.coursetrainerrela.trainerEnName'), width: 100 },
        { prop: 'trainerStatusName', label: this.$t('res.coursetrainerrela.trainerStatus'), width: 120 },
        { prop: 'orgType', label: this.$t('res.coursetrainerrela.orgType'), width: 170 },
        { prop: 'companyDistributor', label: this.$t('res.coursetrainerrela.companyDistributor'), width: 100 },
        { prop: 'trainerfication', label: this.$t('res.coursetrainerrela.trainerfication'), width: 120 },
        { prop: 'city', label: this.$t('res.coursetrainerrela.city'), width: 100 },
        { prop: 'annual', label: this.$t('res.coursetrainerrela.annual'), width: 70 },
        { prop: 'reportAnnualTarget', label: this.$t('res.courseclassroomrela.reportAnnualTarget'), width: 70 },
        { prop: 'trainerRole', label: this.$t('res.coursetrainerrela.trainerrole'), width: 100, formatter: this.trainerRoleFormatter },
        { prop: 'phonenumber', label: this.$t('res.coursetrainerrela.phonenumber'), width: 100 },
        { prop: 'jobcodeJoinDate', label: this.$t('res.coursetrainerrela.jobcodeJoinDate'), width: 120 },
      ],
      companyOptions: [],
      originDataList: [],
      isQualified: 1,
      companyLoading: false
    }
  },
  components: {
    Tag,
    'class-tree': ClassTree
  },
  mounted () {
    this.choseType = '0'
    this.initMethods()
  },
  watch: {
    choseType () {
      this.dataForms = {
        priority: '1',
        qualfication: '10',
        yearTargetIndex: 0,
        trainerPool: ''
      }
      this.courseNameCode = ''
      this.$refs.cityclassRef.resetChecked()
      this.$refs.trainerficationRef.resetChecked()
      this.checkList = []
      this.trainerData = []
      this.dataList2 = []
      this.trainerPoolShow = false
      this.total2 = 0
      this.page2 = 1
      this.limit2 = 10
      this.$refs.selectTrainerinfo.clearSelection()
      this.$refs.selectTrainerinfo2.clearSelection()
    }
  },
  methods: {
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.$request.get(`/learning/courseinfo/page?coursename	=${query}&page=1&limit=20`).then((res) => {
            if (res) {
              this.options = res.records || []
              this.loading = false
              this.isQualified = 1
            }
          })
        }, 100);
      } else {
        this.isQualified = 1
        this.options = [];
      }
    },
    remoteCompanyMethod (query) {
      if (query !== '') {
        this.companyLoading = true;
        setTimeout(() => {
          this.companyLoading = false;
          this.$request.get(`/sys/org/selectOrgByNameOrCode?nameOrCode=${query}&limitOrgType=10,20,30,40,50,60`).then((res) => {
            if (res) {
              this.companyOptions = res || []
            }
          })
        }, 200);
      } else {
        this.companyOptions = [];
      }
    },
    // 点击选择标签打开弹窗
    showSuboLableDlg () {
      this.isQueryShowLable = true
    },
    //关闭选择标签弹窗
    showQueryLableClose(){
      this.isQueryShowLable = false
    },
    cleartrainerLabelName () {
      this.dataForm.trainerLabel = ''
      this.dataForm.labelTypeIdName = ''
      this.checkList = []
      this.trainerLabelShowFlg = false
    },
    trainerLabelShow () {
      this.trainerLabelShowFlg = true
    },
    trainerLabelLeave () {
      this.trainerLabelShowFlg = false
    },
    changeCheckedList (array) {
      this.checkList = array
    },
    onOkLable(){
      let args = this.checkList
      if (args && args !== '' && args.length > 0) {
        let classLabelinfo = []
        let classLabelinfoName = []
        args.forEach(function (item) {
          classLabelinfo.push(item.labelId)
          classLabelinfoName.push(item.labelName)
        })
        this.dataForm.trainerLabel = classLabelinfo.join(',')
        this.dataForm.labelTypeIdName = classLabelinfoName.join(',')
      } else {
        this.dataForm.trainerLabel = ''
        this.dataForm.labelTypeIdName = ''
      }
      this.isQueryShowLable = false
    },
    getBussinessType (val) {
      this.bussinessTypeId = val
    },
    // 根据课程名称编码查询培训师池列表
    searchPool () {
      if(!this.courseNameCode) {
        this.trainerPoolShow = false
        this.trainerData = []
        this.dataList2 = []
        this.total2 = 0
        this.limit2 = 10
        this.page2 = 1
        this.$message({
          message: this.$t('course.courseNameCode'),
          type: 'warning',
          duration: 500
        })
        return false
      }
      this.$request.post('/rm/coursetrainerrela/trainerPoolList', { param: this.courseNameCode }).then((res) => {
        if(res) {
          this.trainerPool = res.map((item)=> {
            return { poolId: item.poolId, poolName: item.poolName, courseId: item.courseId }
          })
          this.dataForms.trainerPool = this.trainerPool[0].poolId
          this.trainerPoolShow = true
          this.getPoolTeacher(this.dataForms.trainerPool)
        }
      }).catch(()=> {
        this.dataList2 = []
        this.courseNameCode = ''
        this.trainerPoolShow = false
        this.trainerData = []
        this.total2 = 0
        this.limit2 = 10
        this.page2 = 1
      })
    },
    // 切换培训师池同时清空所选
    setPoolTeacher (val) {
      this.trainerData = []
      this.isQualified = 1
      this.getPoolTeacher(val)
    },
    // 获取培训师列表
    getPoolTeacher (val) {
      let courseId = ''
      this.dataListLoading2 = true
      this.dataList2 = []
      this.trainerPool.forEach((item) => {
        if(item.poolId===val){
          courseId = item.courseId
        }
      })
      this.$request.get(`/rm/coursetrainerrela/poolTrainerList?courseId=${courseId}&poolId=${val}&page=${this.page2}&limit=${this.limit2}`).then((res) => {
        if(res) {
          this.dataListLoading2 = false
          this.total2 = res.total
          this.dataList2 = res.records
          this.originDataList = res.records
          this.$nextTick(() => {
            this.querSelect()
          })
        }
      }).catch(() => {
        this.dataListLoading2 = false
      })
    },
    filterPoolTeacher () {
      const data = JSON.parse(JSON.stringify(this.originDataList))
      if (this.isQualified === 1) {
        this.dataList2 = data
      } else {
        this.dataList2 = data.filter((item) => item.qualfication === '10')
      }
    },
    // 重新勾选业务标签
    fatherMethod () {
      // 特殊情况，自己国际化
      const language = VueI18n.locale
      if (language === 'zh-CN') {
        this.checkList.forEach(o => {
          o.labelName = o.labelNameCn
        })
      } else {
        this.checkList.forEach(o => {
          o.labelName = o.labelNameEn
        })
      }
    },
    // 获取数据列表
    getDataList () {
      let newDataForm = JSON.parse(JSON.stringify(this.dataForm))
      if ('regionIds' in newDataForm) {
        if (newDataForm.regionIds.length === 0) {
          newDataForm.regionIds = ''
        } else {
          newDataForm.regionIds = newDataForm.regionIds.join(',')
        }
      }
      this.dataListLoading = true
      this.$request.get(
        this.mixinViewModuleOptions.getDataListURL,
        {
          order: this.order,
          orderField: this.orderField,
          page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
          limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
          ...newDataForm
        }
      ).then((res, total, code, data) => {
        this.dataListLoading = false
        let resultList = data.data.records
        this.dataList = resultList
        this.total = this.mixinViewModuleOptions.getDataListIsPage ? parseInt(data.data.total, 10) : 0
        // 延迟加载
        this.$nextTick(() => {
          this.querSelect()
        })
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    // 复用页分页查询
    pageSizeChangeHandle2 (val){
      this.limit2 = val
      this.page2 = 1
      this.getPoolTeacher(this.dataForms.trainerPool)
    },
    pageCurrentChangeHandle2 (val) {
      this.page2 = val
      this.getPoolTeacher(this.dataForms.trainerPool)
    },
    // 初始化
    initMethods () {
      this.dataForm = {
        trainer: '',
        trainerLabel: '',
        labelTypeIdName: '',
        trainerfication: '',
        orgId: '',
        cityList: []
      }
      this.dataForms = {
        priority: '1',
        qualfication: '10',
        qualficationDate: '',
        yearTarget: 0,
        yearTargetIndex: 0
      }
      this.$refs.cityclassRef.resetChecked()
      this.$refs.trainerficationRef.resetChecked()
      this.page = 1
      this.getDataList()
      this.trainerData = []
      this.checkList = []
      this.trainerLabelShowFlg = false
      this.$request.get(`/rm/coursetrainerrela/queryBussinessTypeIdRela`).then((res, total, code, data) => {
        if (data.data != null && data.data != undefined) {
          this.bussinessTypeId = data.data
          this.bussinessTypeChecked = data.data
        }
      })
    },
    // 状态转换
    statusFormatter (row) {
      return Vue.filter('coverEnum')(row.status, 'status')
    },
    // 公司类型转换
    orgFormatter (row) {
      return Vue.filter('coverEnum')(row.orgType, 'orgType')
    },
    // 培训师团队分类转换
    teamClassFormatter (row) {
      return Vue.filter('coverEnum')(row.groupTypeId, 'teaTeamClass')
    },
    // 培训师角色转换
    trainerRoleFormatter (row) {
      return Vue.filter('coverEnum')(row.trainerRoleCode, 'trainerRole')
    },
    selectRedio (selection, row) {
      let result = selection.filter((item) => { return item.trainerId===row.trainerId })
      if (result.length > 0) {
        for(let item of this.trainerInfoList) {
          if (item.trainerId === row.trainerId) {
            this.$message.warning(this.$t('res.coursetrainerrela.ondb'))
            this.$refs.selectTrainerinfo.toggleRowSelection(row, false)
            this.$refs.selectTrainerinfo2.toggleRowSelection(row, false)
            return false
          }
        }
        this.trainerData.push(row)
      } else {
        for(let [index,value] of this.trainerData.entries()) {
          if (row.trainerId === value.trainerId) {
            this.trainerData.splice(index, 1);
            break;
          }
        }
      }
    },
    // 控制可选项
    checkboxT (row) {
      let checkFlgArr = []
      if (this.trainerInfoList && this.trainerInfoList.length > 0) {
        checkFlgArr = this.trainerInfoList.filter((item) => { return row.trainerId === item.trainerId })
      }
      return checkFlgArr.length === 0
    },
    // 全选
    selectAllRedio (selection) {
      let trainerIds = this.trainerData.map((item) => { return item.trainerId }) || []
      if (selection.length > 0) {
        for (let item of selection) {
          if(!trainerIds.includes(item.trainerId)) {
            this.trainerData.push(item)
          }
        }
      } else {
        this.trainerData = []
      }
    },
    // 确认
    onOk () {
      this.$refs['dataForms'].validate((valid) => {
        if (valid) {
          let trainerData = this.trainerData
          if (trainerData.length <= 0) {
            this.$message.warning(this.$t('res.courseclassroomrela.selectTeacherCheck'))
            return false
          }
          trainerData.forEach((item) =>{
            item['priority'] = this.dataForms.priority
            item['qualfication'] = this.dataForms.qualfication
            item['qualficationDate'] = this.dataForms.qualfication==='20' ? this.dataForms.qualficationDate + ' 23:59:59' : ''
            item['yearTarget'] = this.dataForms.yearTargetIndex === 0 ? '0' : this.dataForms.yearTarget + ''
          })
          this.$emit('onOk', trainerData)
          this.$refs.selectTrainerinfo.clearSelection()
        }
      })
    },
    onOk2 () {
      // 如果没有新增的
      let trainerData = this.trainerData
      if (trainerData.length <= 0) {
        this.$message.warning(this.$t('res.courseclassroomrela.selectTeacherCheck'))
        return false
      }
      this.$emit('onOk', trainerData)
      this.$refs.selectTrainerinfo2.clearSelection()
    },
    // 重置查询条件
    resetQuery () {
      this.dataForm = {
        trainer: '',
        trainerLabel: '',
        trainerfication: '',
        orgId: '',
        cityList: []
      }
      this.courseNameCode = ''
      this.choseType = '0'
      this.$refs.cityclassRef.resetChecked()
      this.$refs.trainerficationRef.resetChecked()
      this.checkList = []
      this.queryTrainerInfo()
    },
    // 获取培训师标签
    getTrainerLabelList (args) {
      if (args && args !== '' && args.length > 0) {
        let trainerLabelinfo = []
        args.forEach(function (item) {
          trainerLabelinfo.push(item.id)
        })
        this.dataForm.trainerLabel = trainerLabelinfo.join(',')
      } else {
        this.dataForm.trainerLabel = ''
      }
    },
    // 培训师团队分类
    getTrainerficationList (args) {
      if (args && args !== '' && args.length > 0) {
        let trainerficationSelect = []
        args.forEach(function (item) {
          trainerficationSelect.push(item.id)
        })
        this.dataForm.trainerfication = trainerficationSelect.join(',')
      } else {
        this.dataForm.trainerfication = ''
      }
    },
    getCitySelectList (args) {
      if (args && args !== '' && args.length > 0) {
        let citySelect = []
        args.forEach(function (item) {
          citySelect.push(item.id)
        })
        this.dataForm.cityList = citySelect.join(',')
      } else {
        this.dataForm.cityList = ''
      }
    },
    // 双击选择培训师数据
    onDbTrainer (val) {
      if (val) {
        if (this.trainerData) {
          for(let item of this.trainerData) {
            if (item.trainerId === val.trainerId) {
              this.$message.warning(this.$t('res.courseclassroomrela.ondb'))
              return false
            }
          }
        }
        this.trainerData.push(val)
      }
    },
    // 打开页面时，回填勾选
    querSelect () {
      if (this.trainerData && this.trainerData.length > 0) {
        var map = new Map()
        this.trainerData.forEach((item) => {
          map.set(String(item.trainerId), item)
        })
        if (this.dataList2.length > 0) {
          this.dataList2.forEach((dataitem) => {
            if (map.has(String(dataitem.trainerId))) {
              this.$refs.selectTrainerinfo2.toggleRowSelection(dataitem)
            }
          })
        } else {
          this.dataList.forEach((dataitem) => {
            if (map.has(String(dataitem.trainerId))) {
              this.$refs.selectTrainerinfo.toggleRowSelection(dataitem)
            }
          })
        }
      }
    },
    // 删除已选备件
    handleClose (data) {
      if(this.choseType === '0') {
        for (let item of this.dataList) {
          if (item.trainerId === data.trainerId) {
            this.$refs.selectTrainerinfo.toggleRowSelection(item, false)// 选择当前行
            break
          }
        }
      } else {
        for (let item of this.dataList2) {
          if (item.trainerId === data.trainerId) {
            this.$refs.selectTrainerinfo2.toggleRowSelection(item, false)// 选择当前行
            break
          }
        }
      }
      this.trainerData.splice(this.trainerData.indexOf(data), 1)
    },
    queryTrainerInfo () {
      this.page = 1
      this.getDataList()
    }
  },
  beforeDestroy() {
    this.trainerData = []
    this.checkList = []
    this.courseNameCode = ''
    this.dataForms = {
      priority: '1',
      qualfication: '10',
      yearTargetIndex: 0,
      trainerPool: ''
    }
    this.dataList2 = []
    this.dataList = []
    this.trainerPoolShow = false
    this.total2 = 0
  },
}
</script>
<style lang="scss" scoped>
.mod-rm__coursetrainerrela{
  .mod-rm-coursetrainerrela-tab{
    margin: 0;
  }
  .trainer-pool-li{
    color: #606266;
    line-height: 32px;
    margin-bottom: 20px !important;
    &.trainer-pool-li2{
      text-align: right;
    }
    &.trainer-pool-li3{
      line-height: 0 !important;
      height: 0 !important;
      margin-bottom: 0 !important;
    }
    &.nomargin{
      margin-bottom: 0 !important;
    }
    .pool-module{
      margin-right: 10px;
      float: left;
      .pool-module-name{
        display: block;
        width: 85px;
        float: left;
        margin-right: 12px;
        text-align: right;
        line-height: 32px;
      }
      .pool-module-value{
        display: block;
        float: left;
        .el-date-editor{
          width: 160px !important;
          height: 32px !important;
        }
        .el-input-number{
          width: 160px !important;
          line-height: 32px !important;
          height: 32px !important;
        }
      }
    }
  }
  .rm-course-chose-li{
    color: #606266;
    line-height: 32px;
    margin-bottom: 10px;
    .chose-li-module{
      width: 36%;
      margin-right: 10px;
      float: left;
      display: flex;
      &.chose-li-module2{
        margin-left: 10px;
        width: 21%;
        min-width: 177px;
      }
      &.chose-li-module3{
        width: 66px;
      }
      .module-name{
        display: block;
        margin-right: 12px;
        text-align: right;
      }
      .module-value{
        display: block;
        flex: 1;
      }
    }
  }
  .trainer-chosed-tag {
    margin-bottom: 10px;
    width: 250px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .traninerPool-search-condition {
    .el-form-item {
      width: 90% !important;
    }
  }
  .chose-tab-contain {
    padding-left: 10px !important;
    .el-form-item {
      width: 100% !important;
    }
  }
  .query-button {
    .M-search {
      min-width: 80px !important;
    }
    .el-button {
      padding: 8px 0px !important;
    }
  }
}
</style>
<style lang="scss">
.oneBoxTrainer {
  .el-form-item__label-wrap {
    text-align: right !important;
    margin-right: 12px !important;
  }
}
.oneClassificationTrainersCol .el-form-item {
  width: 95% !important;
}
.twoPopupCity .el-form-item__label-wrap {
  margin-left: 16px !important;
}
.mod-rm__coursetrainerrela{
  .trainer-pool-li{
    .el-form-item__content{
      width: 100% !important;
    }
  }
}
.rm-course-chose-li {
  .module-value2 {
    .el-select {
      .el-input .el-input__inner{
        cursor: text !important;
      }
    }
  }
}
.module-company-select {
  .el-select {
    .el-input .el-input__inner{
      cursor: text !important;
    }
  }
}
.queryBox {
  .el-link {
    cursor: pointer;
  }
}
</style>
